import { z } from 'zod';

const timestampSchema = z.iso.datetime();

/** 사업자등록번호 — 하이픈 없는 숫자 10자리. */
export const businessNumberSchema = z
  .string()
  .regex(/^\d{10}$/, '사업자등록번호는 숫자 10자리여야 합니다.');

/** 세금계산서를 받을 사업자 정보 — 회원이 저장해 두고 주문마다 불러 쓴다. */
export const businessProfileFieldsSchema = z.strictObject({
  businessNumber: businessNumberSchema,
  companyName: z.string().trim().min(1).max(50),
  representativeName: z.string().trim().min(1).max(50),
  address: z.string().trim().min(1).max(200),
  businessType: z.string().trim().min(1).max(50),
  businessItem: z.string().trim().min(1).max(50),
  invoiceEmail: z.email().max(254),
  contactName: z.string().max(50).nullable(),
});
export type BusinessProfileFields = z.infer<typeof businessProfileFieldsSchema>;

export const businessProfileSchema = businessProfileFieldsSchema.extend({
  updatedAt: timestampSchema,
});
export type BusinessProfile = z.infer<typeof businessProfileSchema>;

export const saveBusinessProfileInputSchema = businessProfileFieldsSchema;
export type SaveBusinessProfileInput = z.infer<typeof saveBusinessProfileInputSchema>;

/** 사업자번호 상태 — 국세청 휴폐업 조회 결과. UNKNOWN 은 조회 실패·미등록. */
export const BUSINESS_NUMBER_STATES = ['ACTIVE', 'CLOSED', 'SUSPENDED', 'UNKNOWN'] as const;
export type BusinessNumberState = (typeof BUSINESS_NUMBER_STATES)[number];

export const checkBusinessNumberInputSchema = z.strictObject({
  businessNumber: businessNumberSchema,
});
export type CheckBusinessNumberInput = z.infer<typeof checkBusinessNumberInputSchema>;

export const checkBusinessNumberResultSchema = z.strictObject({
  state: z.enum(BUSINESS_NUMBER_STATES),
});
export type CheckBusinessNumberResult = z.infer<typeof checkBusinessNumberResultSchema>;
